import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

import { useSignUpService } from '../../../services/signUpService';
import loginStyles from '../../Login/index.module.scss';
import { PrivacyLink } from '../../Login/LoginContent/PrivacyLink';
import styles from '../index.module.scss';
import { LoginLink } from './LoginLink';
import SignUpFormButtons from './SignUpFormButtons';
import SignUpWithNameLink from './SignUpWithNameLink';

function SelectSignUpMethod() {
  const {
    challenge,
    state: { signUpMethod, signUpFlowState, invite },
  } = useSignUpService();

  return (
    <div
      className={classNames(loginStyles.boxContainer, 'w-full', {
        [loginStyles.hide]: !!signUpMethod || !isEmpty(challenge) || !!signUpFlowState.state,
      })}
    >
      <div className="absolute -left-6 -top-6 p-0 italic">
        This link will expire {moment.utc(invite?.expiresAt).local().fromNow()}
      </div>
      <span className={loginStyles.title}>Sign up</span>
      <SignUpFormButtons />
      <div className={classNames(styles.links, 'flex flex-col items-center')}>
        <SignUpWithNameLink />
        <LoginLink />
        <PrivacyLink />
      </div>
    </div>
  );
}
export default observer(SelectSignUpMethod);
